export default {
  /* ================== mutations ============== */
  SET_COURSE_DETAIL: 'SET_COURSE_DETAIL',
  UPDATE_COURSE_DETAIL: 'UPDATE_COURSE_DETAIL',
  SET_LUBO_VIDEO: 'SET_LUBO_VIDEO',
  SET_IS_LOADED: 'SET_IS_LOADED',
  SET_NEW_PRESALE_STATUS: 'SET_NEW_PRESALE_STATUS',
  SET_CART_COUNT: 'SET_CART_COUNT',
  SET_DATA_LOADING: 'SET_DATA_LOADING',
  SET_ADD_CART: 'SET_ADD_CART',
  SET_COUPON_LIST: 'SET_COUPON_LIST',
  SET_COUPON_MESSSAGE: 'SET_COUPON_MESSSAGE',

  /* ================== actions ============== */
  GET_NEW_COURSE_DETAIL: 'GET_NEW_COURSE_DETAIL',
  GET_LOGIN_COURSE_DETAIL: 'GET_LOGIN_COURSE_DETAIL',
  GET_NEW_PRESALE_STATUS: 'GET_NEW_PRESALE_STATUS',
  GET_NEW_ADD_CART: 'GET_NEW_ADD_CART',
  GET_NEW_CART_COUNT: 'GET_NEW_CART_COUNT',
  GET_NEW_COUPON_LIST: 'GET_NEW_COUPON_LIST', // 优惠券列表
  GET_NEW_COUPON: 'GET_NEW_COUPON' // 优惠券
}



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/store/types.js